// extracted by mini-css-extract-plugin
module.exports = {"title":"CdsamForm_title__2GxET","input":"CdsamForm_input__wbVbJ"};